import { createContext } from 'react'

export type SignalingStatus = 'connecting' | 'open' | 'closed'

export interface SignalingMessage {
  type: string
  jobId?: string
  payload?: Record<string, unknown>
}

export interface SignalingContextValue {
  status: SignalingStatus
  send: (message: Record<string, unknown>) => boolean
  subscribeToJob: (
    jobId: string,
    handler: (message: SignalingMessage) => void,
  ) => () => void
}

export const SignalingContext = createContext<SignalingContextValue | null>(null)
